import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {AudiPlatformProvider} from "@audi/audi-ui-react";

ReactDOM.render(
    <AudiPlatformProvider>
        <App />
    </AudiPlatformProvider>,
  document.getElementById('root')
);
